import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';

/**
 * Legacy route: /club/:clubId/start-session → Start session page.
 * Preserves ?start=1 as ?quick=1 for Home quick-start flow.
 */
const ClubSessionStartRedirect = () => {
  const { clubId } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const searchParams = new URLSearchParams();
  if (params.get('start') === '1' || params.get('quick') === '1') {
    searchParams.set('quick', '1');
  }
  const search = searchParams.toString();
  const target = `/club/${clubId}/sessions/start${search ? `?${search}` : ''}`;
  return <Navigate to={target} replace state={location.state} />;
};

export default ClubSessionStartRedirect;
